import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormContext } from 'react-hook-form'

import { Box, FormControlLabel, Typography, makeStyles } from '@material-ui/core'
import { Theme } from '@material-ui/core/styles'

import { FormRadioGroup, BlackRadio } from '../../Common'
import { DirectorRole } from '../../../graphql'

const useStyles = makeStyles((theme: Theme) => ({
  titleWrap: {
    margin: theme.spacing(0, 0, 3, 0),
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.25rem',
      lineHeight: '1.75rem',
    },
  },
  genderWrapp: {
    margin: theme.spacing(5, 0, 0, 0),
    [theme.breakpoints.down('xs')]: {
      margin: theme.spacing(4, 0, 0, 0),
    },
  },
  radio: {
    '& .MuiRadio-root': {
      padding: theme.spacing(1, 1),
    },
  },
}))

export const RoleRadioBtns: FC = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { watch } = useFormContext()
  const role = watch('role')

  return (
    <Box className={classes.genderWrapp}>
      <Box className={classes.titleWrap}>
        <Typography variant={'h2'} className={classes.title}>
          {t('role', 'Role')}
        </Typography>
      </Box>
      <Box>
        <FormRadioGroup name="role" value={role || DirectorRole.Executive}>
          <Box mb={1.75}>
            <FormControlLabel
              value={DirectorRole.Executive}
              control={<BlackRadio size="small" />}
              label={t('executive', 'Executive')}
              className={classes.radio}
            />
          </Box>
          <Box mb={1.75}>
            <FormControlLabel
              value={DirectorRole.NonExecutive}
              control={<BlackRadio size="small" />}
              label={t('nonExecutive', 'Non Executive')}
              className={classes.radio}
            />
          </Box>
          <Box mb={3}>
            <FormControlLabel
              value={DirectorRole.ManagingDirector}
              control={<BlackRadio size="small" />}
              label={t('managingDirector', 'Managing Director')}
              className={classes.radio}
            />
          </Box>
        </FormRadioGroup>
      </Box>
    </Box>
  )
}
